<template>
  <div class="index">
    <div class="logo LeftBottom"><img src="../assets/logo.png" alt=""></div>
    <div class="pen"><img src="../assets/1/pen.png" class="wid100" alt=""></div>
    <div class="mapCon Center">
      <div class="map">
        <div class="map_bg">
          <img src="../assets/1/map750.png" class="wid100" alt="">
        </div>
        <div class="title End">
          <img src="../assets/1/1.png" class="wid100" alt="">
        </div>
        <div class="map_mask">
          <img src="../assets/1/mask.png" class="hei100" alt="">
        </div>
        <div class="LootBox">
          <div v-for="box in displayBoxes" :key="box.id" class="box"  :style="{ top: box.top, left: box.left, position: 'absolute' }">
            <img :src="getBoxImage(box.id)" :data-id="box.id" class="boxImg" alt="">
            <img src="../assets/1/2.png" class="light" alt="">
          </div>
        </div>

      </div>

    </div>
    <div class="binocle">
      <img src="../assets/1/binocle.png" class="wid100" alt="">
    </div>
    <div class="share Center">
      <img src="../assets/share.png" class="wid100" alt="">
    </div>
  </div>
</template>

<script>
import rule from "../components/rule";
import MyPrize from "../components/MyPrize";
import BoxShow from "../components/BoxShow";
import Begin from "../components/begin";
import '@/store' // 确保 setActivePinia 在此处生效
import {reqUserInfo,submitAns,reqDraw } from '@/api';
const positions = [
  { top: '5%', left: '0%',url:require('../assets/card/2/1.png') },
  { top: '0%', left: '34%',url:require('../assets/card/2/2.png') },
  { top: '20%', left: '19%',url:require('../assets/card/2/3.png') },
  { top: '21%', left: '54%',url:require('../assets/card/2/4.png')},
  { top: '35%', left: '0%' ,url:require('../assets/card/1/1.png')},
  { top: '41%', left: '35%',url:require('../assets/card/1/2.png') },
  { top: '40%', left: '60%',url:require('../assets/card/1/3.png') },
  { top: '54%', left: '23%',url:require('../assets/card/1/4.png')},
  { top: '60%', left: '3%',url:require('../assets/card/1/5.png') },
  { top: '59%', left: '60%',url:require('../assets/card/1/6.png') },
  { top: '73%', left: '38%',url:require('../assets/card/1/7.png') }
]

// 洗牌算法
function shuffleArray(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

// 为每个箱子随机分配位置
function createRandomBoxes() {
  const shuffledPositions = shuffleArray(positions)
  return shuffledPositions.map((pos, index) => ({
    id: index + 1,
    ...pos
  }))
}

export default {
  name: "index",
  components: {rule, MyPrize, BoxShow,Begin},
  data() {
    return {
      displayBoxes: createRandomBoxes(), // 每个箱子随机分配一个位置
      clickedBoxIds: [],
      showRule: false,
      showMyPrize: false,
      showBox: false,
      myPrizeLevel: {
        code:"",
        type:0
      },
      ShowProgress:false,
      BoxData:{},
      ShowBegin:false,// 显示开始页面
      IsBegin:true,// 是否显示首页按钮
      beginBtn: false,// 是否显示开始寻宝按钮
      DrawBtn: false,// 是否显示抽奖寻宝按钮
      GamePlay:0,
      shareMask:false

    }
  },


  created() {

  },
  mounted() {

  },

  methods: {



    getBoxImage(id) {
      if (this.clickedBoxIds.includes(id)) {
        return require('../assets/1/boxopen/' + id + '.png')
      }
      return require('../assets/1/boxclose/' + id + '.png')
    },





  }
}
</script>

<style scoped>
.share{position: absolute; top:0;left: 0; z-index: 20; background: rgba(0,0,0,0.8); width: 100%; height: 100%;overflow-y: auto;}

.box {
  width: 80px;
  height: 80px;
}

.boxImg {
  width: 100%;
}
.index {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url("../assets/1/bg.jpg") center no-repeat;
  background-size: cover
}

.pen {
  width: 35%;
  position: absolute;
  right: 0;
  top: 0;
}

.mapCon {
  width: 100%;
  height: 100%;
}

.mapCon .map {
  width: 100%;
  position: relative;
}

.mapCon .map .map_bg {
  width: 100%;
}

.mapCon .title {
  position: absolute;
  top: -9.5%;
  width: 100%;
  text-align: center;
  z-index: 2;
}

/*.mapCon .title{width: 100%; height: 24%; z-index: 2; position: relative;}*/
.mapCon .title img {
  width: 90%;
  margin-left: -1%;
}

.mapCon .map_mask {
  position: fixed;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.binocle {
  position: absolute;
  width: 30%;
  left: 0;
  bottom: 0;
  vertical-align: middle
}

.binocle img {
  vertical-align: middle
}

.LootBox {
  position: absolute;
  top: 16%;
  left: 10%;
  width: 80%;
  height: 75%;
  z-index: 2;
}

.LootBox .box {
  position: absolute;
  width: 45%;

}

.LootBox .box .boxImg {
  position: absolute;
  width: 34%;
  top: 27%;
  left: 33%;
  pointer-events: none;
}

.LootBox .box .light {
  width: 100%;
  pointer-events: none;
}



.map .manBtn img {
  width: 45%;
  margin: 0 -4%;
}

.mapCon .nav {
  position: absolute;
  right: 1%;
  top: 45%;
  text-align: center;
  width: 20%;
  z-index: 2;
}

.mapCon .nav span {
  display: inline-block;
  padding: 4% 12%;
  margin: 6% 0;
  vertical-align: middle;
  color: #fff;
  font-size: .85rem;
  background-color: #69431b;
  border-radius: 30px;
  cursor: pointer;
}

/* 淡入淡出过渡 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/share.vue